export default __webpack_public_path__ + "static/num3-ca4c666c2fd31cb5fc162f99669c9008.png";